export enum PhasesProtocols {
  DESABILITAR_MOVE_PARA = "Em processo de coleta",
  DESABILITAR_MOVE_PARA_SEFAZ = "Em Processamento SEFAZ",
  AVALIACAO_LOGISTICA_REVERSA = "Avaliação Logística Reversa",
  PROTOCOLO_CONCLUIDO = "Protocolo concluído",
  AVALIACAO_TORRE_CONTROLE = "Avaliação Torre de Controle",
  EM_ANALISE_PARA_PROCESSAMENTO = "Em Análise para Processamento",
  APROVACAO_DE_DOCUMENTOS = "Aprovação de Documentos",
  AVALIACAO_DIRETORIA_COMERCIAL = "Avaliação Diretoria Comercial",
  AVALIACAO_GERENCIA_COMERCIAL = "Avaliação Gerência Comercial",
  AVALIACAO_LOGISTICA = "Avaliação Logística",
  AVALIACAO_FISCAL = "Avaliação Fiscal",
  COMPENSACAO_NOTA_DE_CREDITO = "Compensação de Nota de Crédito",
  APROVACAO_DE_EXTRAVIO = "Aprovação de extravio",
  PROTOCOLO_CANCELADO = "Protocolo cancelado",
  AVALIACAO_FINANCEIRO = "Avaliação Financeiro",
  RETORNO_SAC = "Retorno do SAC",
  AVALIACAO_QUALIDADE = 'Avaliação Qualidade',
  REANALISE_LOGISTICA_REVERSA = 'Reanálise Logística Reversa',
  DIVERGENCIA_DA_DEVOLUCAO = 'Divergência da devolução',
  COMPLEMENTO_EXTRAVIO = 'Complemento Extravio',
  REGISTRO_EVENTOS_ADVERSOS = 'Registro de eventos adversos',
  AVALIACAO_COSMETOVIGILANCIA = 'Avaliação Cosmetovigilância',
  RETORNO_DA_QUALIDADE = 'Retorno da qualidade',
}

export enum PipefyFieldIdsEnum {
  APROVADOR_DIRETORIA_COMERCIAL = 'aprovador_diretoria_comercial',
  APROVADOR_GERENCIA_COMERCIAL = 'aprovador_ger_ncia_comercial',
  VALIDADO_GESTOR_COMERCIAL = 'validado_gestor_comercial',
  COMENTARIO_INTERNO_27 = 'coment_rio_interno_27',
  ANEXO_3 = 'anexos_3',
  TIPO_SOLUCAO_1 = 'tipo_da_solu_o_1',
  NUMERO_PD = 'n_mero_da_pd',
  STATUS_PD = 'status_da_pd',
  ITEM_FRACIONADO = 'item_fracionado',
  VALOR_CREDITO_AO_CLIENTE = 'valor_do_cr_dito_ao_cliente',
  CLASSIFICACAO_EXTRAVIO = 'classifica_o_protocolo_extravio',
  ANALISE_DA_CAUSA= 'an_lise_da_causa',
  AVALIACAO_DE_EVENTO_ADVERSO =  'avalia_o_de_evento_adverso',
  INFORMAR_NUMERO_PLANO_ACAO = 'informar_n_do_plano_de_a_o',
}

export enum PipefyFieldLabelEnum {
  GRUPO_RESPONSAVEL = "Grupo responsável",
  COMENTARIO_INTERNO = "Comentário interno",
  ANEXOS = "Anexos",
  VALIDADO_GESTOR_COMERCIAL = "Validado Gestor Comercial",
  VALIDADO_DIRETORIA_COMERCIAL = "Validado Diretoria Comercial"
}

export enum EnumPipefyInputFieldIds {
  ANEXOS_SUBMETIDOS = "anexos_submetidos",
  ANEXO_RECLAMACAO_TECNICA = "anexo_reclama_o_t_cnica",
  ANEXOS_BOLETIM_OCORRENCIA = "anexar_arquivo_boletim_de_ocorr_ncia",
  ANEXOS_ARQUIVOS = "anexar_arquivo_3",
  PDF_CARTA_TROCA = "pdf_carta_de_troca",
  ANEXOS_BOLETIM_OCORRENCIA_COMPLEMENTO_EXTRAVIO = "boletim_de_ocorr_ncia",
  ANEXOS_AUTORIZACAO_DADOS = "anexo_autoriza_o_de_dados"

}

export enum EnumPipefyInputTypes {
  ANEXOS = "attachment"
}

export enum EnumDisableContext {
  Button = "button",
  Input = "input"
}

export enum ReasonNameEnum {
  FALTA_DE_VOLUME = "FALTA DE VOLUME",
  CONFIRMACAO_DE_ENDERECO_ENTREGA = "CONFIRMAÇÃO DE ENDEREÇO DE ENTREGA",
  ENTREGA_DIVERGENTE_DANFE = "ENTREGA DIVERGENTE DO DANFE",
}

export enum CategoryNameEnum {
  LOGISTICA = "LOGISTICA",
  RECLAMACAO_TECNICA = "RECLAMAÇÃO TÉCNICA",
  DEVOLUCAO = "DEVOLUÇÃO",
}